export * from '@fhs/routing/src/routes/auth/verify/index';
export { default } from '@fhs/routing/src/routes/auth/verify/index';
